export default __webpack_public_path__ + "static/media/Frame 6779.c1a469db.png";